import React, {useState, useEffect } from 'react';
import { 
         Grid,
         LinearProgress,
         Paper,
         TextField,
        } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
    Router as RouterIcon,
}from '@material-ui/icons';
import { 
    LoadingOutlined as LoadingOutlinedIcon,
    SaveOutlined as SaveOutlinedIcon,
   } from '@ant-design/icons';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useAuth } from "../Auth";
import Swal from 'sweetalert2';
import { 
    Button as ButtonAntd,
    Checkbox as CheckboxAntd,
    Popconfirm,
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd, 
} from 'antd';
const moment = require('moment-timezone');  
const arrMeses = ['','Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const TiposTrabajos =[
    'INSTALACION',
    'SOPORTE',
    'RETIRO',
    'CAMBIO DE DOMICILIO',
    "OTROS"
];

const Soportes = [
    "Cambio Router",
    "Cambio ONT",
    "Cambio CPE",
    "Cambio Clave",
    "Fibra Cortada",
    "Otros"
];

function OT_ADD(){
    const { authTokens, ageWork, setRuta } = useAuth(); 
    const { enqueueSnackbar} = useSnackbar()
    const [ getDatos, setDatos] = useState({
        Tipo:'',
        Status:'',
        Nombres:'',
        CI:'',
        Celular:'',
        Correo:'',
        Direccion:'',
        idServicio:'',
        idForMikrotik:'',
        numOt:0,
        Fecha:(()=>{
            const laZona="America/Guayaquil";
            const laFecha = moment().tz(laZona).format();
            return laFecha.split('T')[0]
        })(),
        Hora:'09:00',
        Observacion:'',
        Tecnico:'',
        NombresTecnico:'',
        Zona:'',
        isSendNotification:true
    });
    const [ dataZona, setDataZona ] = useState([]);
    const [ getClientes, setClientes ] = useState([]);
    const [ getTecnicos, setTecnicos ] = useState([]);
    const [ zonaSelected, setZonaSelected ] = useState({});
    const [ isSavingOt, setSavingOt ] = useState(false);
    const [ getServicios, setServicios ] = useState([]);
    const [ isByNombres, setByNombres ] =  useState(true);
    const [ serviceSelected, setServiceSelected ] = useState({});
    const [ getCliente, setCliente ] = useState({});
    const [ getMacsOntArr, setMacsOntArr ] = useState([]);
    const [ getMacsRouterArr, setMacsRouterArr ] = useState([]);
    const [ getMacsCpeArr, setMacsCpeArr ] = useState([]);
    const [ onlyOnts, setOnlyOnts ] = useState([]);
    const [ onlyRouters, setOnlyRouters ] = useState([]);
    const [ onlyCpes, setOnlyCpes ] = useState([]);
    const [ getStock, setStock ] = useState([]);
    

    useEffect(
        ()=>{        
            (async ()=>{ 
                const PeticionZona = await fetch(`/api/zonas/byEmpresa/${authTokens.Empresa}`);
                const resultZona = await PeticionZona.json();
                if(authTokens.Type === 'ADMINISTRADOR'){
                    setDataZona(resultZona);
                }else{
                    const arrUserZ = authTokens.Zonas.map(el=>el.Zona);
                    const arrZ = resultZona.filter(el=> arrUserZ.includes(el.Zona));
                    setDataZona(arrZ); 
                }
                setRuta('/OT/Crear');
                const laZona="America/Guayaquil";
                const laFecha = moment().tz(laZona).format().split('T')[0];
                setDatos({...getDatos, Fecha:laFecha}); 
                const dataTecnicos = await fetch(`/api/users/tecnicos/byEmpresa/${authTokens.Empresa}`);
                const jsonTecnicos = await dataTecnicos.json();
                setTecnicos(jsonTecnicos);
                const getStock_ = await fetch(`/api/Stocks/byEmpresa/${authTokens.Empresa}`);
                const jsnStock_ = await getStock_.json();
                setStock(jsnStock_);
                const getModelsO = [...new Set(jsnStock_.filter(el=>el.Tipo === 'ONT').map(el=>el.Modelo))];
                const getModelsR = [...new Set(jsnStock_.filter(el=>el.Tipo === 'ROUTER').map(el=>el.Modelo))];
                const getModelsC = [...new Set(jsnStock_.filter(el=>el.Tipo === 'CPE').map(el=>el.Modelo))];
                setOnlyOnts(getModelsO);
                setOnlyRouters(getModelsR);
                setOnlyCpes(getModelsC);    

        })();       
        },[] // eslint-disable-line react-hooks/exhaustive-deps
    );


    const handleSelectZona = (valZ)=>{
        fetch('/api/clientes/byEmpresa&Zona',
            { 
                method:'POST', 
                body: JSON.stringify({Empresa:authTokens.Empresa, Zona:valZ}), 
                headers:{'Content-Type': 'application/json'}
            }) 
        .then(response=> response.json())
        .then(result =>{
            if(result.Status){
                enqueueSnackbar(result.Status, {variant:'error'})
            }else{
                const resultClientes = result.filter(value=>value.Status === 'Activo');
                const arrClientes = [];
                for(const x in resultClientes){
                    const objeto = {...resultClientes[x]};
                    const arrFiltrado = resultClientes[x].Servicios.filter(value=>value.ZonaService === valZ);
                    if(arrFiltrado.length > 0){
                        objeto.Servicios = arrFiltrado;
                        arrClientes.push(objeto);
                    }
                }    
                setClientes(arrClientes);
                const arrFil =  (dataZona.filter(value=> value.Zona.toString() === valZ.toString()))[0];
                setZonaSelected(arrFil);
                setDatos({...getDatos, Zona:valZ});
            }
        });
    };

    const handleClearZona = ()=>{
        const laZona="America/Guayaquil";
        const laFecha = moment().tz(laZona).format();
        //setSelectedZona(false);
        setDatos({
            Nombres:'',
            CI:'',
            Celular:'',
            Correo:'',
            Direccion:'',
            idServicio:'',
            idForMikrotik:'',
            numOt:0,
            Fecha:laFecha.split('T')[0],
            Hora:'09:00',
            Observacion:'',
            Tecnico:'',
            NombresTecnico:'',
            Zona:'',
            isSendNotification:true
        });   
        setServicios([]);
        setClientes([]);
        setByNombres(true);
        setServiceSelected({});
        setZonaSelected({});
        setCliente({});
    };

    const handleSelectName = (e, value, reason)=>{
        if(reason === 'select-option'){
            if(isByNombres){
                const arrFil = getClientes.filter(value2=>value2.Nombres.toString() === value.toString())[0];
                if(arrFil.Servicios.length === 1){
                    setServiceSelected(arrFil.Servicios[0]);
                    setDatos({...getDatos, 
                        Nombres:value,
                        CI:arrFil.CI,
                        Celular:arrFil.Celular.map(el=>el.celular)[0],
                        Correo:arrFil.Correo.map(el=>el.correo)[0],
                        Direccion:arrFil.Servicios[0].Direccion,
                        idServicio:arrFil.Servicios[0]._id,
                        idForMikrotik:arrFil.Servicios[0].idForMikrotik
                    }); 
                }else{
                    setDatos({...getDatos, 
                        Nombres:value,
                        CI:arrFil.CI,
                        Celular:arrFil.Celular.map(el=>el.celular)[0],
                        Correo:arrFil.Correo.map(el=>el.correo)[0],
                        Direccion:'',
                        idServicio:'',
                        idForMikrotik:'',}); 
                    setServicios(arrFil.Servicios);
                    setCliente({arrFil});
                }
            }else{
                const arrFil = getClientes.filter(value2=>value2.CI.toString() === value.toString())[0];
                if(arrFil.Servicios.length === 1){
                    setServiceSelected(arrFil.Servicios[0]);
                    setDatos({...getDatos, 
                        Nombres:value,
                        CI:arrFil.CI,
                        Celular:arrFil.Celular.map(el=>el.celular)[0],
                        Correo:arrFil.Correo.map(el=>el.correo)[0],
                        Direccion:arrFil.Servicios[0].Direccion,
                        idServicio:arrFil.Servicios[0]._id,
                        idForMikrotik:arrFil.Servicios[0].idForMikrotik
                    }); 
                }else{
                    setDatos({...getDatos, 
                        Nombres:arrFil.Nombres,
                        CI:value,
                        Celular:arrFil.Celular.map(el=>el.celular)[0],
                        Correo:arrFil.Correo.map(el=>el.correo)[0],
                        Direccion:'',
                        idServicio:'',
                        idForMikrotik:'',}); 
                    setServicios(arrFil.Servicios);
                    setCliente({arrFil});
                }
            }  
        }else{
            setDatos({...getDatos, 
            Nombres:'',
            CI:'',
            Celular:'',
            Correo:'',
            Direccion:'',
            idServicio:'',
            idForMikrotik:''});   
            setServicios([]);
            setCliente({});
        }
             

    };

    const handleSelectServicio = (e, value, reason)=>{
        if(reason === 'select-option'){
            const arrFil = getServicios.filter(value2=>value2.Direccion.toString() === value.toString())[0];
            setServiceSelected(arrFil);
            setDatos({...getDatos, 
                Direccion:value,
                idForMikrotik:arrFil.idForMikrotik,
                idServicio:arrFil._id});
            
        }else{
            setDatos({...getDatos, 
                Direccion:'',
                idForMikrotik:'',
                idServicio:''});   
            setServiceSelected({});
        }    
    };

    const handleSelectTipo = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos, Tipo:value, Detalle:''});
        }else{
            setDatos({...getDatos, Tipo:'', Detalle:''});   
        }    
    };

    const handleSelectTecnico = (e, value, reason)=>{
        if(reason === 'select-option'){
            const arrFil = getTecnicos.find(el=> el.NombresReducidos === value);
            setDatos({...getDatos, Tecnico:value, NombresTecnico:arrFil.Nombres, CorreoTecnico:arrFil.Mail});
        }else{
            setDatos({...getDatos, Tecnico:'', NombresTecnico:'', CorreoTecnico:''});   
        }    
    };

    const handleDatos = (e) =>{ setDatos({...getDatos, [e.target.id]: e.target.value}) };

    const handleAddOt = ()=>{
        setSavingOt(true);
        const laZona="America/Guayaquil";
        const laFecha = moment().tz(laZona).format();
        const elMes = arrMeses[parseInt(laFecha.split('-')[1])];
        const objeto = {...getDatos};
        const objetoS = {...serviceSelected};
            objetoS.MacOnu = getDatos.MacOnu;
            objetoS.SN = getDatos.SN;
            objetoS.OnuMarca = getDatos.OnuMarca;
            objetoS.MacRouter = getDatos.MacRouter ? getDatos.MacRouter : '';
            objetoS.Router = getDatos.Router ? getDatos.Router : '';
        objeto.dataService = objetoS;
        objeto.dataCliente = getCliente;
        objeto.dataServicePast = serviceSelected;
        objeto.InfoZona = zonaSelected;
        objeto.MesCreacion = elMes;
        objeto.ageWork = ageWork;
        objeto.Empresa = authTokens.Empresa;
        fetch('/api/Ots',{
            method:'POST',
            body: JSON.stringify(objeto),
            headers:{
                'Content-Type': 'application/json'
            }
        }) 
        .then(response=> response.json())
        .then(result =>{
            setSavingOt(false);
            if(result._id){
                Swal.fire({
                    title:`SE HA CREADO LA OT N° ${result.numOT}`,
                    icon:'success',
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonColor:'#005596',
                    width:600,
                    confirmButtonText:'OK',
                }).then((result)=>{
                    if(result.isConfirmed){
                        handleClearZona();
                    }
                })
            }else{
                enqueueSnackbar(result.status, {variant:'error'});
                
            } 
        });
    };

    const handleByNombres = (checked)=>{ setByNombres(checked); };

    const handleSelectDetalle = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos, Detalle:value});
        }else{
            setDatos({...getDatos, Detalle:''});   
        }    
    };

    const handleOnus = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos, Onu:value, MacOnu:'', SN:'', OnuMarca:'', MacRouter:'', RouterNSerie:'', Router:'' });
            const arr = getStock.filter(elStock=> elStock.Modelo === value);
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            setMacsOntArr(arr1.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatos({...getDatos, Onu:'', MacOnu:'', SN:'', OnuMarca:'' });
            setMacsOntArr([]);
        }
    };

    const handleRouters = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos, MacRouter:'', RouterNSerie:'', Router:value });
            const arr = getStock.filter(elStock=> elStock.Modelo === value);
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            setMacsRouterArr(arr1.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatos({...getDatos, MacRouter:'', RouterNSerie:'', Router:'' });
            setMacsRouterArr([]);
        }
    };

    const handleSelectMacOnu = (e, value, reason)=>{ 
        if(value !== ''){
            const arrFilter = getStock.filter(el=> el.Mac === value);
            if(arrFilter.length > 0 ){
                setDatos({...getDatos, MacOnu:value, SN:arrFilter[0].SN, OnuMarca:arrFilter[0].Marca });
            }else{
                setDatos({...getDatos, MacOnu:value, SN:'', OnuMarca:'' });
            }
        }else{
            setDatos({...getDatos, MacOnu:'', SN:'', OnuMarca:'' });
        }
    };

    const handleSelectMacRouter = (e, value, reason)=>{ 
        if(value !== ''){
            setDatos({...getDatos, MacRouter:value,});
        }else{
            setDatos({...getDatos, MacRouter:''});
        }
    };

    const handleCpes = (e, value, reason)=>{
        if(reason === 'select-option'){
            setDatos({...getDatos,  Modelo:value, MacModelo:''});
            const arr = getStock.filter(elStock=> elStock.Modelo === value);
            const arr1 = arr.filter(elStock=> elStock.Mac !== null && elStock.Mac !== undefined && elStock.Mac !== '');
            setMacsCpeArr(arr1.filter(el=>el.Status === 'Disponible'));
        }else{
            setDatos({...getDatos, Modelo:value, MacModelo:''});
            setMacsCpeArr([]);
        }
    };

    const handleSelectMacCpe = (e, value, reason)=>{ 
        if(value !== ''){
            setDatos({...getDatos, MacModelo:value });
        }else{
            setDatos({...getDatos, MacModelo:'' });
        }
    };

    return(
        <Grid container spacing={2} justifyContent='center' style={{padding:10, height:'90vh',overflowY:'auto', width:'100%', border:'1px solid #D0D3D4', borderRadius:5}}>
            <Grid item  lg={5} md={6} sm={10} xs={12}>
                <Paper elevation={3} style={{padding:15, width:'100%'}}>
                    <Grid container spacing={2} justifyContent='center'>
                        <Grid item xs={12} style={{height:5}}>
                            {isSavingOt &&  <LinearProgress color='secondary' /> }
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container justifyContent='space-between' spacing={1}>
                                <Grid item xs={8}>
                                    <Autocomplete
                                        id="Zona"
                                        options={dataZona.map(value=>value.Zona)}
                                        value={getDatos.Zona || ''}                              
                                        renderInput={(params) => <TextField {...params} label="Zona" variant="outlined" size='small' fullWidth color='primary'/>}
                                        onChange={(e,value, reason)=>{
                                            if(reason ===  'clear'){
                                                handleClearZona()
                                            }else{
                                                handleSelectZona(value);
                                            }
                                        }}  
                                    />
                                </Grid>
                                <Grid item  xs={3} style={{display:'grid', placeContent:'center'}}>
                                    <TooltipAntd title="CI O NOMBRES" color='BLUE' >
                                        <SwitchAntd checkedChildren="ON" unCheckedChildren="OFF" checked={isByNombres} onChange={handleByNombres} />
                                    </TooltipAntd>  
                                </Grid>
                                <Grid item xs={1} style={{display:'grid', placeContent:'center'}}>
                                    <TooltipAntd title="ENVIAR NOTIFICACION A TECNICO" color='BLUE' >
                                        <CheckboxAntd onChange={({target})=>{ setDatos({...getDatos, isSendNotification:target.checked})}} checked={getDatos.isSendNotification}/>
                                    </TooltipAntd>
                                </Grid>
                            </Grid> 
                        </Grid>                     
                        <Grid item xs={12}>
                            <Autocomplete
                                id="Cliente"
                                options={getClientes.map(value=> isByNombres ? value.Nombres : value.CI)}
                                value={ isByNombres ? getDatos.Nombres : getDatos.CI || ''}                              
                                renderInput={(params) => <TextField {...params} label="Cliente" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectName}  
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="Servicio"
                                options={getServicios.map(value=>value.Direccion)}
                                value={getDatos.Direccion || ''}                              
                                renderInput={(params) => <TextField {...params} label="Servicio" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectServicio}  
                            />
                        </Grid>
                        <Grid item  md={6} xs={12}>
                            <Autocomplete
                                id="Tipo"
                                options={TiposTrabajos}
                                value={getDatos.Tipo || ''}                              
                                renderInput={(params) => <TextField {...params} label="Tipo" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectTipo}  
                            />
                        </Grid>
                        {   getDatos.Tipo === 'SOPORTE' && 
                            <Grid item md={6} xs={12}>
                                <Autocomplete
                                    id="Detalle"
                                    options={Soportes}
                                    value={getDatos.Detalle || ''}                              
                                    renderInput={(params) => <TextField {...params} label="Detalle" variant="outlined" size='small' fullWidth color='primary'/>}
                                    onChange={handleSelectDetalle}  
                                />
                            </Grid>
                        }

                        {
                            getDatos.Detalle === 'Cambio ONT' &&
                            <React.Fragment>
                                <Grid item sm={6} xs={12} >
                                    <Autocomplete
                                        id='Onu'                                            
                                        options={onlyOnts}
                                        value={getDatos.Onu || ''}
                                        onChange={handleOnus}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                            startAdornment: <RouterIcon/>,
                                        }} fullWidth label="ONU" variant="outlined" required size='small'/>}
                                    />
                                </Grid>
                                <Grid item sm={6} xs={12} >
                                    <Autocomplete
                                        id='MacOnu'                                            
                                        options={getMacsOntArr}
                                        inputValue={getDatos.MacOnu || ''}
                                        onInputChange={handleSelectMacOnu}
                                        getOptionLabel={(option) => option.Mac}
                                        renderOption={(option) => (
                                            <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                                        )}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>,}} fullWidth label="Mac Onu" variant="outlined" required size='small'/>}
                                    />
                                </Grid>
                            </React.Fragment>
                        }
                
                        {
                            getDatos.Detalle === 'Cambio Router' &&
                            <React.Fragment>
                                <Grid item sm={6} xs={12} >
                                    <Autocomplete
                                        id='Router'                                            
                                        options={onlyRouters}
                                        value={getDatos.Router || ''}
                                        onChange={handleRouters}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                            startAdornment: <RouterIcon/>,
                                        }} fullWidth label="Router" variant="outlined" required size='small'  />}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Autocomplete
                                        id='MacRouter'                                            
                                        options={getMacsRouterArr}
                                        inputValue={getDatos.MacRouter || ''}
                                        onInputChange={handleSelectMacRouter}
                                        getOptionLabel={(option) => option.Mac}
                                        renderOption={(option) => (
                                            <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                                        )}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>}} fullWidth label="Mac Router Nueva" variant="outlined" required size='small'/>}
                                    />
                                </Grid>
                            </React.Fragment>
                        }

                        {
                           getDatos.Detalle === 'Cambio CPE' &&
                            <React.Fragment>
                                <Grid item sm={6} xs={12} >
                                    <Autocomplete
                                        id='CPE'                                            
                                        options={onlyCpes}
                                        value={getDatos.Modelo || ''}
                                        onChange={handleCpes}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps,
                                            startAdornment: <RouterIcon/>,
                                        }} fullWidth label="CPE" variant="outlined" required size='small'  />}
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Autocomplete
                                        id='MacCpe'                                            
                                        options={getMacsCpeArr}
                                        inputValue={getDatos.MacModelo || ''}
                                        onInputChange={handleSelectMacCpe}
                                        getOptionLabel={(option) => option.Mac}
                                        renderOption={(option) => (
                                            <span style={{color: option.Status === 'Disponible' ? 'green' : option.Status === 'No Disponible' ? 'red' : 'orange'}}>{option.Mac}</span>
                                        )}
                                        renderInput={(params) => <TextField {...params} InputProps={{...params.InputProps, startAdornment: <RouterIcon/>}} fullWidth label="Mac Cpe Nueva" variant="outlined" required size='small'/>}
                                    />
                                </Grid>
                            </React.Fragment>
                        }
                        <Grid item md={ getDatos.Tipo === 'SOPORTE' ? 12 : 6 } xs={12}>
                            <Autocomplete
                                id="Tecnico"
                                options={getTecnicos.map(el=>el.NombresReducidos)}
                                value={getDatos.Tecnico || ''}                              
                                renderInput={(params) => <TextField {...params} label="Tecnico" variant="outlined" size='small' fullWidth color='primary'/>}
                                onChange={handleSelectTecnico}  
                            />
                        </Grid>
                        <Grid item xl={8} lg={8} md={7} xs={12} > 
                            <TextField 
                                id='Fecha'
                                fullWidth
                                label='Fecha'
                                value={getDatos.Fecha || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                                type='date'
                            />                     
                        </Grid>
                        <Grid item xl={4} lg={4} md={5} xs={12} > 
                            <TextField 
                                id='Hora'
                                fullWidth
                                label='Hora'
                                value={getDatos.Hora || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                                type='time'
                            />                     
                        </Grid>
                        <Grid item xs={12} > 
                            <TextField 
                                id='Observacion'
                                fullWidth
                                label='Observacion'
                                value={getDatos.Observacion || ''}
                                onChange={handleDatos}
                                variant='outlined'
                                size='small'
                                margin='dense'
                                multiline
                            />                     
                        </Grid>
                        <Grid item xs={6}>
                            <ButtonAntd block type="danger"  size='large'  onClick={handleClearZona}>
                                RESETEAR
                            </ButtonAntd>     
                        </Grid>
                        <Grid item xs={6}>            
                            <Popconfirm
                                title="DESEA CREAR OT?"
                                onConfirm={handleAddOt}
                                okText="SI"
                                cancelText="NO"
                            >
                                <ButtonAntd block type="primary"  size='large' icon={isSavingOt ? <LoadingOutlinedIcon/> :<SaveOutlinedIcon/>} >
                                    GUARDAR
                                </ButtonAntd>
                            </Popconfirm>
                        </Grid> 
                    </Grid>   
                </Paper>
            </Grid>
            
        </Grid>
    );
};

function ADD_OT(){
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <OT_ADD />
        </SnackbarProvider>
    );
};

export default ADD_OT;